<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    v-if="isLoading !== 0 && isLoading !== false"
    :class="[
      'm-loading-wrap',
      {
        'm-loading-wrap__center': center,
        'm-loading-wrap__full': full,
      },
    ]"
  >
    <div v-if="isLoading !== -1" class="m-loading">
      <div class="loading" :class="{ 'loading--compact': isCompactSpinner }">
        <img :style="imgSpinnerStyle" :src="require('@/assets/img/loading.png')" />
      </div>
      <div v-if="isLoading === -1" class="loading-fail">
        <p class="fail-text">Data failed loading. Please reload.</p>
        <div class="fail-btn" @click="fail">Reload</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: [Boolean, Number],
      default: true,
    },
    center: {
      type: [Boolean],
      default: false,
    },
    full: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: false,
    },
    /** When set (e.g. float-bubble iframe), scales spinner so it is not clipped in small hosts. */
    spinnerWidthPx: {
      type: Number,
      default: undefined,
    },
    statement: {
      type: String,
      default: '',
    },
  },
  computed: {
    isCompactSpinner() {
      return typeof this.spinnerWidthPx === 'number';
    },
    imgSpinnerStyle() {
      const w = this.spinnerWidthPx;
      return { width: this.isCompactSpinner ? `${w}px` : '75px' };
    },
  },
  methods: {
    fail() {
      this.$emit('fail');
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/variable.scss';
@keyframes circles {
  to {
    transform: rotate(360deg);
  }
  from {
    transform: rotate(0deg);
  }
}

.m-loading-wrap {
  &__center {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__full {
    z-index: 2;
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
  }
}
.m-loading {
  text-align: center;
  font-size: 12 / $rem;
  background: transparent;
  color: $dark;
  .loading {
    animation: circles 1s infinite;
    animation-timing-function: linear;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    &--compact {
      margin-bottom: 0;
    }
    &:before {
      height: 30 / $rem;
      width: 30 / $rem;
      line-height: 1;
      font-size: 30 / $rem;
    }
  }
  .loading-fail {
    text-align: center;
    margin: 10 / $rem 0;
    &:before {
      display: block;
      font-size: 36 / $rem;
    }
    .fail-text {
      margin-top: 10 / $rem;
      white-space: nowrap;
      word-break: keep-all;
      margin-bottom: 24 / $rem;
    }
    .fail-btn {
      color: $outline-button-text-color;
      height: 36 / $rem;
      line-height: 36 / $rem;
      padding: 0 28 / $rem;
      display: inline-block;
      border: 1px solid $outline-button-outline-color;
      border-radius: 3 / $rem;
    }
  }
}
</style>
